import { MotionProps, Variant, motion } from 'motion/react';
import Image, { ImageProps } from 'next/image';
import { forwardRef, useState } from 'react';

const imageMotionVariant: Record<string, Variant> = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const AnimatedImage = (props: ImageProps & MotionProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleLoad = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setIsLoaded(true);
    props.onLoad && props.onLoad(event);
  };

  return (
    <MotionNextImage
      sizes="100%"
      fill
      {...props}
      onLoad={handleLoad}
      initial={{ opacity: 0 }}
      variants={imageMotionVariant}
      animate={isLoaded ? 'visible' : 'hidden'}
    />
  );
};

export const ImageRef = (props: ImageProps, ref) => {
  return <Image {...props} ref={ref} />;
};

export const NextImageRef = forwardRef<HTMLImageElement, ImageProps>(ImageRef);

export const MotionNextImage = motion(NextImageRef, {
  forwardMotionProps: true,
});
